import { forwardRef, type HTMLAttributes } from 'react'
import { createPortal } from 'react-dom'

type PortalDropdownMenuProps = HTMLAttributes<HTMLDivElement> & {
  show?: boolean
  close?: () => void
}

export const PortalDropdownMenu = forwardRef<HTMLDivElement, PortalDropdownMenuProps>(({ show, close, children, ...rest }, ref) => {
  void close

  const menu = (
    <div ref={ref} {...rest}>
      {show ? children : null}
    </div>
  )

  return typeof document === 'undefined' ? menu : createPortal(menu, document.body)
})
PortalDropdownMenu.displayName = 'PortalDropdownMenu'
